import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';

import { ReviewSectionStyle } from 'App/components/EHR/styles';
import { useUserContext } from 'App/contexts/UserContext';
import useFetchPatientIdentifiers from 'App/hooks/useFetchPatientIdentifiers';
import useFetchPatientPrescriptions from 'App/hooks/useFetchPatientPrescriptions';
import { dateOnlySlashesFormat, dateTimeSlashesFormat, formatUtcDate } from 'App/services/DateService';
import { branchSettingsPropType, patientPropType } from 'Shared/types';

const EhrEncounterReviewContent = ({ patient, branchSettings, medicationList }) => {
    const user = useUserContext();

    const { data: patientIdentifiers } = useFetchPatientIdentifiers(patient.id);
    const primaryIdentifier = (!patientIdentifiers ? [] : Object.values(patientIdentifiers)).find(
        (i) => i.identifierType === branchSettings.ehrPrimaryIdType
    );
    const patientPrimaryIdentifier = primaryIdentifier?.identifier;

    const { data: prescriptions } = useFetchPatientPrescriptions(patient.id);
    const prescriptionsList = Object.values(prescriptions || {}).filter(
        (p) => !!p.physician?.firstName && !!p.physician?.lastName
    );
    return (
        <div>
            <div>
                Completed on {dayjs().format(dateTimeSlashesFormat)}, by {user.first_name} {user.last_name}
                {user.suffix && `, ${user.suffix}`}
            </div>

            <ReviewSectionStyle>
                <strong>Patient</strong>
                <div>
                    Patient Name: {patient.lastName}, {patient.firstName} {patient.middleInitial}
                </div>
                <div>DOB: {formatUtcDate({ date: patient.birthDate, format: dateOnlySlashesFormat })}</div>
                <div data-testid="patient-ehr-id">EHR ID: {patientPrimaryIdentifier}</div>
            </ReviewSectionStyle>

            <ReviewSectionStyle>
                <strong>Providers </strong>
                {!prescriptionsList.length ? (
                    '--'
                ) : (
                    <ul id="ehr-provider-list">
                        {prescriptionsList.map((p) => (
                            <li key={p.id}>
                                {p.physician?.firstName} {p.physician?.lastName}
                            </li>
                        ))}
                    </ul>
                )}
            </ReviewSectionStyle>

            <ReviewSectionStyle>
                <strong>Activity Medications </strong>
                {!medicationList.length ? (
                    '--'
                ) : (
                    <ul>
                        {medicationList.map((med) => (
                            <li key={med.medication?.id}>{med.medication?.name}</li>
                        ))}
                    </ul>
                )}
            </ReviewSectionStyle>
        </div>
    );
};

EhrEncounterReviewContent.propTypes = {
    patient: patientPropType.isRequired,
    branchSettings: branchSettingsPropType.isRequired,
    medicationList: PropTypes.arrayOf(
        PropTypes.shape({
            medication: PropTypes.shape({
                id: PropTypes.string,
                displayName: PropTypes.string,
            }),
        })
    ).isRequired,
};

export default EhrEncounterReviewContent;
